var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Transition',{attrs:{"name":"slide-down"}},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"user-regions-list"},_vm._l((_vm.regions),function(region){return _c('li',{key:region.id,class:[
                'user-regions-list__item pointer',
                {
                    active: _vm.activeRegion && _vm.activeRegion.id === region.id,
                },
            ],on:{"click":function($event){return _vm.selectRegion(region)}}},[_vm._v("\n            "+_vm._s(region.name)+"\n        ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }